import store from '@/store';
import sensors from '@/utils/sensors';
import { match } from 'pinyin-pro';
import { message } from 'ant-design-vue';

export default {
  /**
   * 下拉列表筛选
   * @param {*} input 输入值
   * @param {*} option 选项
   * @returns
   */
  filterOption(input, option) {
    return match(option.componentOptions.children[0].text, input);
  },
  getUserData(projectId) {
    if (projectId === null || projectId === undefined) {
      return [];
    }
    if (store.getters.projectUsers(projectId, null) === null) {
      store.dispatch('getUsers', projectId);
    }
    return store.getters.projectUsers(projectId);
  },

  trackClick(param = {}) {
    const title = document.title;
    const url = window.location.href;
    const url_path = window.location.pathname;
    sensors.track(
      '$buttonclick',
      buildParam({
        $title: title,
        $url: url,
        $url_path: url_path,
        ...param
      })
    );
  },

  trackPageview(param = {}) {
    const title = document.title;
    const url = window.location.href;
    const url_path = window.location.pathname;
    sensors.track(
      '$pageview',
      buildParam({
        $title: title,
        $url: url,
        $url_path: url_path,
        ...param
      })
    );
  }
};

export const buildParam = (param = {}) => {
  const userInfo = JSON.parse(window.localStorage.getItem('user_info') || '{}');
  const baseParam = {
    $user_key: userInfo.id || 0,
    $event_session_id: userInfo.id || 0,
    $element_name: param.name || null,
    $element_content: param.label || null
  };
  ['name', 'label'].forEach(key => {
    Reflect.deleteProperty(param, key);
  });
  const _param = param || {};
  Object.assign(baseParam, _param);
  return baseParam;
};

export const listToTreeBak = (list, parentId = 0) => {
  const menuObj = {};
  list.forEach(item => {
    item.children = [];
    menuObj[item.id] = item;
  });
  return list.filter(item => {
    if (item.parent_id !== parentId) {
      if (menuObj[item.parent_id] === undefined) {
        menuObj[item.parent_id].children = [];
      }
      console.log(item.parent_id, parentId, menuObj[item.parent_id]);
      menuObj[item.parent_id].children.push(item);
      return false;
    }
    return true;
  });
};

/**
 * 列表转树结构数据
 * @param {*} arr
 * @param {*} id
 * @param {*} key
 * @returns
 */
export function listToTree(arr, id = null, key = 'parent_id') {
  return arr.filter(item => item[key] === id).map(item => ({ ...item, children: listToTree(arr, item.id) }));
}

export const routeListToTree = (list, parentId = 0) => {
  // 1. 构建 id 到 route 的映射，方便后续快速查找
  const routeMap = new Map();
  const routes = list.map(item => {
    const route = {
      id: item.id,
      parent_id: item.parent_id,
      path: item.route,
      name: item.code,
      component: resolve => require([`@/${item.component}`], resolve),
      redirect: item.redirect,
      meta: {
        title: item.name,
        code: item.code,
        icon: item.icon,
        id: item.id,
        parent_id: item.parent_id,
        hide: item.hide
      },
      children: []
    };
    routeMap.set(item.id, route);
    return route;
  });

  // 2. 构建树结构
  const tree = [];
  for (const route of routes) {
    if (route.parent_id !== parentId && routeMap.has(route.parent_id)) {
      // 将当前路由添加到父路由的 children 中
      routeMap.get(route.parent_id).children.push(route);
    } else if (route.parent_id === parentId) {
      // 将当前路由添加到根节点
      tree.push(route);
    }
  }

  // 3. 设置父级路由的 redirect
  for (const route of routes) {
    if (route.children.length > 0) {
      // 找到第一个 meta.hide === 0 的叶子节点
      let stack = [...route.children];
      let visibleLeaf = null;
      while (stack.length) {
        const node = stack.shift();
        if (node.children.length > 0) {
          stack = node.children.concat(stack);
        } else if (node.meta.hide === 0) {
          visibleLeaf = node;
          break;
        }
      }
      // 构建 redirect 路径
      if (visibleLeaf) {
        const pathParts = [visibleLeaf.path];
        let parent = routeMap.get(visibleLeaf.parent_id);
        while (parent) {
          pathParts.unshift(parent.path);
          parent = routeMap.get(parent.parent_id);
        }
        route.redirect = pathParts.join('/');
      }
    }
  }

  return tree;
};

/**
 * 权限校验
 * @param {*} code 权限code
 * @param {*} projectId 项目ID
 * @param {*} permissions 权限列表
 * @returns
 */
export function permissionRequired(code, projectId, permissions = null) {
  if (permissions === null) {
    permissions = store.state.permissions;
  }
  let temp = permissions[projectId] || [];
  if (projectId !== 0) {
    temp = temp.concat(permissions[0] || []);
  }
  return temp.includes(code);
}

/**
 * 复制文本
 * @param {*} vaule 文本内容
 */
export function onCopy(vaule) {
  const oInput = document.createElement('input');
  oInput.value = vaule;
  document.body.appendChild(oInput);
  oInput.select(); // 选择对象;
  document.execCommand('Copy'); // 执行浏览器复制命令
  oInput.remove();
  message.success('复制成功');
}

/**
 * 写入Cookies，如果day为0，则代表删除Cookies
 * @param {*} cname  Key
 * @param {*} value Value
 * @param {*} day 过期时间
 */
export function setCookies(cname, value = '', day = 0) {
  let expires = 'Thu, 01 Jan 1970 00:00:00 UTC';
  if (day > 0) {
    const date = new Date();
    date.setDate(date.getDate() + day);
    expires = date.toString();
  } else {
    value = '';
  }
  // document.cookie = cname + '=' + value + ';expires=' + date + ';path=/';
  document.cookie = cname + '=' + value + ';expires=' + expires + ';domain=.cdfsunrise.com;path=/';
}

/**
 * 读取本地Cookies信息，如果本地Cookies信息不存在时，读取localstorge信息
 * @param {*} cname
 * @returns
 */
export function getCookies(cname = 'token') {
  let token = '';
  const name = cname + '=';
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    const c = ca[i].trim();
    if (c.indexOf(name) === 0) {
      token = c.substring(name.length, c.length);
      break;
    }
  }
  if (!token) {
    token = window.localStorage.getItem(cname);
  }
  return token === undefined ? '' : token;
}

/**
 * 判断字符串是否含有html标签，简写规则：/<[^>]+>/g
 * @param {*} content
 * @returns
 */
export function checkHtml(content) {
  if (content) {
    const reg = /<(?:(?:\/?[A-Za-z]\w*\b(?:[=\s](['"]?)[\s\S]*?\1)*)|(?:!--[\s\S]*?--))\/?>/g;
    return reg.test(content);
  }
  return null;
}

/**
 * 函数防抖 是n秒后延迟执行，多用于页面scroll滚动，窗口resize，防止按钮重复点击
 * @param {Function} fn 是我们需要包装的事件回调
 * @param {Number} delay 是每次推迟执行的等待时间
 * @returns
 */
export function debounce(fn, delay) {
  // 记录上一次触发的时间
  var timer = null;
  return () => {
    // 保留调用时的this上下文
    var context = this;
    // 保留调用时传入的参数
    var args = arguments;
    // 每次事件被触发时，都去清除上一次延时器
    if (timer) clearTimeout(timer);
    // 设立新的定时器
    timer = setTimeout(() => {
      fn.apply(context, args);
    }, delay);
  };
}

export function getRandomStr(len = 10) {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const tempLen = chars.length;
  let tempStr = '';
  for (let i = 0; i < len; ++i) {
    tempStr += chars.charAt(Math.floor(Math.random() * tempLen));
  }
  return tempStr;
}

/**
 * 处理Markdown格式，提取纯文本内容
 * @param {string} content Markdown内容
 * @param {number} maxLength 最大长度限制
 * @returns {string} 处理后的纯文本
 */
export function extractMarkdownText(content, maxLength = 50) {
  if (!content) return '';

  // 处理Markdown格式，提取纯文本内容
  const textContent = content
    // 移除Markdown链接格式 [text](url)
    .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1')
    // 移除Markdown图片格式 ![alt](url)
    .replace(/!\[([^\]]*)\]\([^)]+\)/g, '$1')
    // 移除Markdown代码块 ```
    .replace(/```[\s\S]*?```/g, '')
    // 移除行内代码 `code`
    .replace(/`([^`]+)`/g, '$1')
    // 移除粗体 **text** 或 __text__
    .replace(/\*\*([^*]+)\*\*/g, '$1')
    .replace(/__([^_]+)__/g, '$1')
    // 移除斜体 *text* 或 _text_
    .replace(/\*([^*]+)\*/g, '$1')
    .replace(/_([^_]+)_/g, '$1')
    // 移除删除线 ~~text~~
    .replace(/~~([^~]+)~~/g, '$1')
    // 移除标题标记 #
    .replace(/^#{1,6}\s+/gm, '')
    // 移除列表标记 - * +
    .replace(/^[\s]*[-*+]\s+/gm, '')
    // 移除数字列表标记 1. 2. 等
    .replace(/^[\s]*\d+\.\s+/gm, '')
    // 移除引用标记 >
    .replace(/^>\s+/gm, '')
    // 移除水平分割线 --- 或 ***
    .replace(/^[-*]{3,}$/gm, '')
    // 移除HTML标签
    .replace(/<[^>]*>/g, '')
    // 移除多余的空行和空格
    .replace(/\n\s*\n/g, '\n')
    .replace(/\s+/g, ' ')
    .trim();

  // 截取指定长度
  return textContent.substring(0, maxLength) + (textContent.length > maxLength ? '...' : '');
}

/**
 * 检查编辑器内容中是否存在正在上传的图片
 * @param {string} content - 编辑器内容
 * @returns {boolean} - 是否存在正在上传的图片
 */
export const hasUploadingImages = content => {
  if (!content) return false;

  try {
    // 匹配所有card元素的value属性
    const cardRegex = /value="([^"]*)"/g;
    const matches = content.matchAll(cardRegex);

    for (const match of matches) {
      if (!match[1]) continue;

      try {
        // 解码并解析card数据
        const decoded = decodeURIComponent(match[1].replace('data:', ''));
        const cardData = JSON.parse(decoded);

        // 检查是否为正在上传的图片
        if (cardData.status === 'uploading') {
          return true;
        }
      } catch (e) {
        // 解析失败则继续检查下一个
        continue;
      }
    }
  } catch (e) {
    console.error('Error checking uploading images:', e);
  }

  return false;
};
